
const IcoCheck = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

/* ════════════════════════════════════════════
   MOBILE STEPPER BAR
════════════════════════════════════════════ */
export default function MobileStepperBar({ steps, currentStep, onGoToStep }) {
  const pct = steps.length > 1 ? Math.round((currentStep / (steps.length - 1)) * 100) : 0;
  const currentLabel = steps[currentStep]?.label || '';
  return (
    <div className="ck-stepper-mobile notranslate" translate="no">
      <div className="ck-mob-step-header">
        <span className="ck-mob-step-label">{currentLabel}</span>
        <span className="ck-mob-step-count">Paso {currentStep + 1} de {steps.length}</span>
      </div>
      <div className="ck-mob-step-bar">
        <div className="ck-mob-step-fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="ck-mob-step-pills">
        {steps.map((s, i) => {
          const state = i < currentStep ? 'done' : i === currentStep ? 'active' : 'pending';
          return (
            <button
              key={s.key}
              className={`ck-mob-pill ${state}`}
              onClick={() => state === 'done' && onGoToStep(i)}
              disabled={state === 'pending'}
            >
              <span className="ck-mob-pill-icon" aria-hidden="true">
                {state === 'done' && <IcoCheck />}
                {state === 'active' && <span className="ck-mob-pill-dot" />}
              </span>
              <span className="ck-mob-pill-label">{s.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
